export default __webpack_public_path__ + "static/media/card-consultation.28988523.svg";